import { useEffect } from "react";

const useTaskOnboardingWebsite = ({ step }) => {
  useEffect(() => {
    //reset last styles
    const prev_highlight_element = document.getElementById("title_select");
    prev_highlight_element.style.zIndex = 1;
    prev_highlight_element.style.backgroundColor = "transparent";

    const handleResize = () => {
      const container_element = document.getElementsByClassName(
        "dashboard-layout__content__wrapper"
      )?.[0];
      const pointer_element = document.getElementsByClassName(
        "task-onboarding__tooltip"
      )?.[0];
      const highlight_element = document.getElementById("website_select");
      const hightlight_position = highlight_element?.getBoundingClientRect();
      const hightlight_position_x = hightlight_position?.left;
      const hightlight_position_y = hightlight_position?.top;
      highlight_element.style.zIndex = 1101;
      highlight_element.style.backgroundColor = `#E1E6EB`;
      container_element.style.position = "unset";

      pointer_element.style.flexDirection = "row";

      const pointer_position_top = hightlight_position_y;
      const pointer_position_left =
        hightlight_position_x + hightlight_position?.width;

      pointer_element.style.top = `${pointer_position_top}px`;
      pointer_element.style.left = `${pointer_position_left}px`;
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [step]);

  return null;
};

export default useTaskOnboardingWebsite;
